import styled from 'styled-components';
import { Stack } from '@mui/material';

export const ToolsDrawerSectionHeader = styled(Stack)({
  padding: '8px 12px',
});

export const ToolsDrawerSectionContent = styled(Stack)({
  padding: '0 12px',
});
